import { Paper, Tab, Tabs } from "@material-ui/core";
import { find } from "lodash";
import React, { useState } from "react";
import Constants from "../../utils/constants";
import "./styles.scss";

const { LANGUAGES } = Constants;
const { MonToSat, SunAndHol } = LANGUAGES;

const CustomSwitch = (props) => {
  const { defaultShow, titles, select, schedules, switchSchedule, language } =
    props;

  const [selected, setSelected] = useState(0);

  const handleChange = (event, newValue) => {
    setSelected(newValue);
    switchSchedule(newValue);
  };

  const renderTitle = (schedule) => {
    const { fromDow, toDow } = schedule;
    const dowDictionary = [
      { dow: 0, zh: "日", cn: "日", en: "Sunday" },
      { dow: 1, zh: "一", cn: "一", en: "Monday" },
      { dow: 2, zh: "二", cn: "二", en: "Tuesday" },
      { dow: 3, zh: "三", cn: "三", en: "Wednesday" },
      { dow: 4, zh: "四", cn: "四", en: "Thursday" },
      { dow: 5, zh: "五", cn: "五", en: "Friday" },
      { dow: 6, zh: "六", cn: "六", en: "Saturday" },
    ];
    let str = "";
    if (fromDow !== toDow) {
      if (language === "zh" || language === "cn") {
        str += "星期";
      }
      str += find(dowDictionary, { dow: fromDow })[language];
      if (fromDow + 1 === toDow) {
        str += language === "zh" || language === "cn" ? "及" : "&";
      } else {
        str += language === "zh" || language === "cn" ? "至" : " to ";
      }
      str += find(dowDictionary, { dow: toDow })[language];
    } else {
      if (language === "zh" || language === "cn") {
        str += "星期";
      }
      str += `${find(dowDictionary, { dow: fromDow })[language]}`;
      if (fromDow === 0) {
        if (language === "zh") {
          str += "及公眾假期";
        } else if (language === "cn") {
          str += "及公众假期";
        } else {
          str += "& Public Holiday";
        }
      }
    }

    return str;
  };

  return (
    // <div className="switch">
    //   <Grid container className="base">
    //     {schedules.length > 0 &&
    //       schedules.map((schedule, index) => {
    //         return (
    //           <Grid
    //             item
    //             className={`text ${
    //               selected === index ? "selected" : ""
    //             } ${language}`}
    //             onClick={toggle}
    //           >
    //             {MonToSat[language]}
    //           </Grid>
    //         );
    //       })}
    //     {/* <Grid
    //       item
    //       className={`text ${selected === 0 ? "selected" : ""} ${language}`}
    //       onClick={toggle}
    //     >
    //       {MonToSat[language]}
    //     </Grid>
    //     <Grid
    //       item
    //       className={`text ${selected === 1 ? "selected" : ""} ${language}`}
    //       onClick={toggle}
    //     >
    //       {SunAndHol[language]}
    //     </Grid> */}
    //   </Grid>
    //   {/* <div className={`button ${selected === 0 ? "left" : "right"}`}></div> */}
    // </div>
    <div className="switch">
      <Paper square>
        <Tabs
          value={selected}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleChange}
          aria-label="disabled tabs example"
          variant="fullWidth"
        >
          {schedules.length > 0 &&
            schedules.map((schedule, index) => {
              return <Tab label={renderTitle(schedule)} />;
            })}
        </Tabs>
      </Paper>
    </div>
  );
};

export default CustomSwitch;
